import $ from 'jquery';
import BaseController from 'chairisher/_controller';

/**
 * Controller that binds actions for the password reset page
 */
class PasswordResetController extends BaseController {
    /** @inheritDoc * */
    bindPageActions() {
        $('#js-password-reset-form').buttonLoadingHelper();
    }
}

export default PasswordResetController;
